import dayjs from 'dayjs';
import { DATEFORMAT_LOCAL_STATE } from '@ps20-frontend/utils';
import { Selbstbeteiligung, Zahlungsart, Zahlweise } from '@ps20/bff-models';
import { IAppState } from './appState';

const beginnDatum = dayjs().add(1, 'd').format(DATEFORMAT_LOCAL_STATE);
export const INITIAL_STATE: IAppState = {
  version: 5,
  antragsnummer: null,
  versicherungsnehmer: {
    geburtsdatum: null,
    familienstand: null,
    isAssekuranztarif: false,
    adresse: null,
  },
  transientState: {
    zurueckZumShopModalOpen: false,
    role: null,
    featureToggles: {},
    regexps: {},
    tarifierungIsInProgress: false,
    priceGuarantee: false,
    fehlerCodeTaas: '',
    vorvertragVorschaeden: null,
    kooperationen: null,
  },
  taasInfo: {
    hashedTaasRequest: '',
    hashedRiskData: '',
    rbdNachlass: 0,
    tbNachlass: 0,
    aktionsnachlass: 0,
    savedRbdNachlass: 0,
    savedTbNachlass: 0,
    savedAktionsnachlass: 0,
    anpassungsFaktor: 0,
    specialInfo: {
      aktionsnachlass: 0,
      erhrisiko: 0,
      nachlman: 0,
      zuschlman: 0,
    },
  },
  jahresbeitrag: 0,
  gesamtbeitragMitRabatt: 0,
  gesamtbeitrag: 0,
  savedGesamtbeitragMitRabatt: 0,
  savedJahresbeitragMitRabatt: 0,
  vertragsoptionen: {
    selbstbeteiligung: Selbstbeteiligung.SELBSTBETEILIGUNG_0000,
    versicherungssumme: 75000000,
    zahlungsweise: Zahlweise.MONATLICH,
    vertragslaufzeit: 3,
    ausgewaehltevertragslaufzeit: 3,
    zahlungsart: Zahlungsart.LASTSCHRIFT,
    beginnDatum: calculateNextAprilFirst(beginnDatum),
    aenderungdatum: calculateNextAprilFirst(beginnDatum),
    vorversicherungVorhanden: true,
  },
  produkt: null,
  rabattstufe: null,
};

export function calculateNextAprilFirst(dateString: string): string {
  const date = dayjs(dateString, DATEFORMAT_LOCAL_STATE);
  const yearOffset = date.month() < 3 || (date.month() === 3 && date.date() === 1) ? 0 : 1;
  return dayjs()
    .date(1)
    .month(3)
    .year(date.year())
    .add(yearOffset, 'year')
    .format(DATEFORMAT_LOCAL_STATE);
}
